import angular from 'angular';

import PositionMergeModal from '@web/positions/PositionMerge/PositionMergeModalAngular';

import { colors } from '../../../constants';
import r2a from '../../../../react/angularIntegration/r2a';
import positionsEmptyStateComponent from '../../../../react/positions/EmptyStates/PositionsEmptyStateAngular';

import positionsComponent from './positionsComponent';
import managePositionComponent from './managePositionComponent';
import positionsGroupComponent from './positionsGroupComponent';

const positionsModule = angular.module('sling.dashboard.manage.positions', []);

positionsModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage.positions', {
    abstract: true,
    url: '/positions',
    template: '<ui-view></ui-view>',
  });

  $stateProvider.state('dashboard.manage.positions.list', {
    url: '?tab',
    template:
      "<manage-positions include-archived=\"true\" column-subset=\"['name', 'memberCount', 'options']\"></manage-positions>",
    data: {
      title: 'Positions',
    },
  });

  $stateProvider.state('dashboard.manage.positions.add', {
    url: '/add',
    controllerAs: 'ctrl',
    controller: function addPositionController() {
      this.group = {
        type: 'position',
        members: [],
        wages: [],
        color: colors.getRandom(),
      };
    },
    template: '<manage-position group="ctrl.group"></manage-position>',
  });

  $stateProvider.state('dashboard.manage.positions.edit', {
    url: '/{groupId:[0-9]+}?tab',
    reloadOnSearch: false,
    controller: function editPositionController(
      PersonaCollection,
      Restangular,
      $state,
      $stateParams,
      previousState
    ) {
      'ngInject';

      this.initialTab = $stateParams.tab || '';
      this.previousState = previousState;
      const group = PersonaCollection.positions.find((g) => String(g.id) === $stateParams.groupId);
      if (!group) {
        $state.go('dashboard.manage.positions.list');
      } else {
        this.group = Restangular.copy(group);
      }
    },
    template: `
          <manage-position
            ng-if="ctrl.group"
            group="ctrl.group"
            previous-state="ctrl.previousState"
            tab="{{ ctrl.initialTab }}">
           </manage-position>`,
    controllerAs: 'ctrl',
    resolve: {
      previousState($transition$, $state) {
        const from = $transition$.from();
        return {
          name: from.name,
          params: { ...$state.params },
        };
      },
    },
  });
});

positionsModule.component('managePositions', positionsComponent);
positionsModule.component('managePosition', managePositionComponent);
positionsModule.component('positionsGroup', positionsGroupComponent);
positionsModule.component('rPositionsEmptyState', r2a(positionsEmptyStateComponent));
positionsModule.component('rPositionMergeModal', PositionMergeModal);

export default positionsModule.name;
